module.exports = __webpack_public_path__ + "img/logo.9046ec9a.png";